import { Button } from "@progress/kendo-react-buttons";

const EditCommandCell = (props) => {
   console.log('props', props)
   return (<td><Button themeColor="tertiary" onClick={props.onClick} size={props.size}>{props.text}</Button></td>)
};

export default EditCommandCell;